<template>
  <div class="security">
    <el-container>
      <el-header style="height: 100px">
        <Head></Head>
      </el-header>
      <el-main class="security_main_body">
        <div class="hero-section">
          <div class="hero-content">
            <h1 class="hero-title">
              <span class="gradient-text">企业级IP代理</span>
              <span class="normal-text">解决方案</span>
            </h1>
            <div class="hero-description">
              专为企业量身定制的IP代理服务，提供全球化网络访问解决方案，助力企业数字化转型
            </div>
            <div class="hero-features">
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="el-icon-data-line"></i>
                </div>
                <div class="feature-text">
                  <h3>高性能</h3>
                  <p>千万级IP资源池</p>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="el-icon-money"></i>
                </div>
                <div class="feature-text">
                  <h3>低成本</h3>
                  <p>企业专属价格</p>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="el-icon-service"></i>
                </div>
                <div class="feature-text">
                  <h3>专业服务</h3>
                  <p>7*24小时支持</p>
                </div>
              </div>
            </div>
            <div class="hero-actions">
              <el-button @click="openWeChatChat" type="primary" class="primary-button" round>
                免费咨询方案
              </el-button>
              <el-button @click="startTrial" class="secondary-button" round>
                开始7天免费试用
              </el-button>
            </div>
          </div>
          <div class="hero-image">
            <div class="stats-cards">
              <div class="stat-card">
                <div class="stat-number">30000<span>+</span></div>
                <div class="stat-label">企业用户</div>
              </div>
              <div class="stat-card">
                <div class="stat-number">99.9<span>%</span></div>
                <div class="stat-label">服务可用率</div>
              </div>
              <div class="stat-card">
                <div class="stat-number">200<span>+</span></div>
                <div class="stat-label">覆盖国家</div>
              </div>
            </div>
          </div>
        </div>

        <div class="features-section">
          <div class="features-grid">
            <div class="feature-card">
              <div class="card-icon">
                <img src="http://apiupss.ppfly.top/images/banner_card_icon1.svg" alt="免费测试"/>
              </div>
              <h3>企业免费测试</h3>
              <p>7天免费试用，全功能体验</p>
              <ul class="feature-list">
                <li><i class="el-icon-check"></i>无需信用卡</li>
                <li><i class="el-icon-check"></i>专人技术指导</li>
                <li><i class="el-icon-check"></i>企业定制方案</li>
              </ul>
            </div>
            <div class="feature-card">
              <div class="card-icon">
                <img src="http://apiupss.ppfly.top/images/banner_card_icon2.svg" alt="专属优惠"/>
              </div>
              <h3>企业专属优惠</h3>
              <p>量身定制的价格方案</p>
              <ul class="feature-list">
                <li><i class="el-icon-check"></i>阶梯价格</li>
                <li><i class="el-icon-check"></i>长期优惠</li>
                <li><i class="el-icon-check"></i>定制折扣</li>
              </ul>
            </div>
            <div class="feature-card">
              <div class="card-icon">
                <img src="http://apiupss.ppfly.top/images/banner_card_icon3.svg" alt="技术支持"/>
              </div>
              <h3>专业技术支持</h3>
              <p>全天候技术保障服务</p>
              <ul class="feature-list">
                <li><i class="el-icon-check"></i>7*24响应</li>
                <li><i class="el-icon-check"></i>专人对接</li>
                <li><i class="el-icon-check"></i>现场支持</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="solutions-section">
          <div class="section-header">
            <h2 class="section-title">企业解决方案</h2>
            <p class="section-description">
              为全球30000+企业提供资源、技术、服务等多维度支持，助力企业实现业务增长
            </p>
          </div>

          <div class="solutions-carousel">
            <el-carousel :interval="4000" type="card" height="500px">
              <el-carousel-item v-for="item in carousellist" :key="item.id">
                <div class="solution-card" :class="'solution-' + item.id">
                  <div class="solution-content">
                    <div class="solution-header">
                      <div class="solution-info">
                        <h3 class="solution-title">{{ item.Hname }}</h3>
                        <p class="solution-description">{{ item.text }}</p>
                      </div>
                      <div class="solution-icon">
                        <i :class="getSolutionIcon(item.Hname)"></i>
                      </div>
                    </div>
                    
                    <div class="solution-features">
                      <div class="feature-item" v-for="(text, key) in {textA: item.textA, textB: item.textB, textC: item.textC}" :key="key">
                        <div class="feature-header">
                          <div class="feature-icon">
                            <i :class="getFeatureIcon(key)"></i>
                          </div>
                          <div class="feature-text">
                            <h4>{{ text.A }}</h4>
                            <p>{{ text.B }}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="solution-details">
                      <div class="details-section">
                        <h4 class="details-title">
                          <i class="el-icon-star-on"></i>
                          核心功能
                        </h4>
                        <div class="details-grid">
                          <div class="detail-item" v-for="feature in item.features" :key="feature">
                            <i class="el-icon-check"></i>
                            <span>{{ feature }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="details-section">
                        <h4 class="details-title">
                          <i class="el-icon-s-operation"></i>
                          应用场景
                        </h4>
                        <div class="details-grid">
                          <div class="detail-item" v-for="scenario in item.scenarios" :key="scenario">
                            <i class="el-icon-success"></i>
                            <span>{{ scenario }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="solution-illustration">
                      <img :src="getSolutionImage(item.id)" :alt="item.Hname"/>
                    </div>

                    <div class="solution-action">
                      <el-button
                        @click="lunboclick(item.Hname)"
                        :class="['action-button', item.Hname === '资源定制' ? 'primary' : 'secondary']"
                        type="primary"
                        round>
                        {{ item.buname }}
                        <i class="el-icon-arrow-right"></i>
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <div class="cta-section">
          <div class="cta-content">
            <div class="cta-text">
              <h2>开启您的企业级IP代理服务</h2>
              <p>专业的大数据IP代理服务平台，为您提供安全、稳定、高效的一站式解决方案</p>
              <ul class="cta-features">
                <li>
                  <i class="el-icon-check"></i>
                  <span>7天免费试用</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>专属技术支持</span>
                </li>
                <li>
                  <i class="el-icon-check"></i>
                  <span>企业定制方案</span>
                </li>
              </ul>
            </div>
            <div class="cta-actions">
              <el-button @click="startTrial" type="primary" class="cta-button primary" round>
                立即开始免费试用
                <i class="el-icon-arrow-right"></i>
              </el-button>
              <el-button @click="openWeChatChat" class="cta-button secondary" round>
                <i class="el-icon-service"></i>
                咨询企业方案
              </el-button>
            </div>
          </div>
          <div class="cta-stats">
            <div class="stat-item">
              <div class="stat-icon">
                <i class="el-icon-data-line"></i>
              </div>
              <div class="stat-value">30000+</div>
              <div class="stat-label">企业用户</div>
            </div>
            <div class="stat-item">
              <div class="stat-icon">
                <i class="el-icon-location"></i>
              </div>
              <div class="stat-value">200+</div>
              <div class="stat-label">覆盖国家</div>
            </div>
            <div class="stat-item">
              <div class="stat-icon">
                <i class="el-icon-connection"></i>
              </div>
              <div class="stat-value">99.9%</div>
              <div class="stat-label">服务可用率</div>
            </div>
          </div>
        </div>

        <div class="testimonials-section">
          <div class="section-header">
            <h2 class="section-title">客户成功案例</h2>
            <p class="section-description">全球30000+企业的共同选择，为您提供值得信赖的服务</p>
          </div>
          
          <div class="testimonials-grid">
            <div class="testimonial-card">
              <div class="testimonial-header">
                <div class="company-info">
                  <h3 class="company-name">广州**科技有限公司</h3>
                  <span class="company-industry">数据分析服务</span>
                </div>
              </div>
              <div class="testimonial-content">
                <div class="testimonial-quote">
                  <i class="el-icon-chat-dot-round quote-icon"></i>
                  <p>我们与奇迹ip建立了长久的合作伙伴关系，显著提升了数据搜索与处理速度，帮助我们更精准地分析各项数据源，从而获得深入的市场洞察。</p>
                </div>
                <div class="testimonial-metrics">
                  <div class="metric">
                    <span class="metric-value">300%</span>
                    <span class="metric-label">效率提升</span>
                  </div>
                  <div class="metric">
                    <span class="metric-value">50%</span>
                    <span class="metric-label">成本降低</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="testimonial-card">
              <div class="testimonial-header">
                <div class="company-info">
                  <h3 class="company-name">北京**科技有限公司</h3>
                  <span class="company-industry">大数据服务</span>
                </div>
              </div>
              <div class="testimonial-content">
                <div class="testimonial-quote">
                  <i class="el-icon-chat-dot-round quote-icon"></i>
                  <p>奇迹ip在资源和规模方面都能满足我们的业务需求，并且为我们定制了企业适用方案，不仅降低了业务成本，效率也大幅度提高。</p>
                </div>
                <div class="testimonial-metrics">
                  <div class="metric">
                    <span class="metric-value">200%</span>
                    <span class="metric-label">并发提升</span>
                  </div>
                  <div class="metric">
                    <span class="metric-value">40%</span>
                    <span class="metric-label">成本优化</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="testimonial-card">
              <div class="testimonial-header">
                <div class="company-info">
                  <h3 class="company-name">**数字科技股份有限公司</h3>
                  <span class="company-industry">数据采集服务</span>
                </div>
              </div>
              <div class="testimonial-content">
                <div class="testimonial-quote">
                  <i class="el-icon-chat-dot-round quote-icon"></i>
                  <p>与奇迹ip的合作解决了数据采集过程中的稳定性问题，高效的运作模式大大减少了我们的维护成本和人力资源投入。</p>
                </div>
                <div class="testimonial-metrics">
                  <div class="metric">
                    <span class="metric-value">99.9%</span>
                    <span class="metric-label">稳定性</span>
                  </div>
                  <div class="metric">
                    <span class="metric-value">60%</span>
                    <span class="metric-label">成本节省</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </el-main>
    </el-container>
    <Xuanfuret></Xuanfuret>
  </div>
</template>

<script>
import Head from "@/components/head/head.vue";
import Footer from "@/components/footer/footer.vue";
import Xuanfuret from "@/components/xuanfuret/xuanfuret.vue";
export default {
  name: 'EnterpriseServices',
  components: {
    Head,
    Footer,
    Xuanfuret,
  },
  data() {
    return {
      ruleForm: {
        gsqc: "",
        phones: "",
        eim: "",
        gsqt: "",
        sygj: "",
        dltype: "",
        checkboxItems: [
          { label: "动态住宅：", inputValue: "", placeholder: "每月用量/G" },
          {
            label: "动态数据中心：",
            inputValue: "",
            placeholder: "每月用量/G",
          },
          { label: "静态住宅：", inputValue: "", placeholder: "每月用量/个" },
          {
            label: "独享数据中心：",
            inputValue: "",
            placeholder: "每月用量/个",
          },
        //   { label: "长效ISP：", inputValue: "", placeholder: "每月用量/G" },
        ],
        type: [],
      },
      rules: {
        gsqc: [{ required: true, message: "请输入公司全称", trigger: "blur" }],
        phones: [
          { required: true, message: "请输入您的手机号", trigger: "blur" },
        ],

        region: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个代理类型",
            trigger: "change",
          },
        ],
      },
      carousellist: [
        {
          id: 0,
          Hname: "企业级动态住宅IP",
          text: "基于全球运营商网络构建的高质量住宅IP代理服务，为企业提供稳定、高效的数据采集解决方案",
          textA: {
            A: "全球优质资源",
            B: "覆盖200+国家地区，千万级IP资源池，确保采集任务高效完成",
          },
          textB: {
            A: "智能负载均衡",
            B: "先进的调度系统，支持每秒10万+并发请求，自动故障转移",
          },
          textC: {
            A: "性价比方案",
            B: "按量计费，阶梯价格优惠，节省70%以上成本，7天免费测试",
          },
          features: [
            "自动IP轮换",
            "并发无限制",
            "地区精确筛选",
            "协议全兼容",
            "实时IP检测",
            "API全球加速"
          ],
          scenarios: [
            "跨境电商选品",
            "全球市场调研",
            "价格监控分析",
            "SEO排名查询"
          ],
          buname: "立即体验",
        },
        {
          id: 1,
          Hname: "企业专属代理池",
          text: "为企业量身定制的独享代理服务，提供稳定可靠的专属IP资源池，满足企业特定业务需求",
          textA: {
            A: "独享IP资源",
            B: "专属IP池隔离，确保数据安全，支持IP自动更换，稳定性99.9%",
          },
          textB: {
            A: "场景化配置",
            B: "根据业务场景定制代理规则，支持自定义出口区域、会话保持等",
          },
          textC: {
            A: "一站式服务",
            B: "专属技术支持，7*24小时响应，提供部署实施和运维保障",
          },
          features: [
            "独享带宽",
            "IP动态更换",
            "地区自定义",
            "协议定制",
            "数据加密",
            "实时监控"
          ],
          scenarios: [
            "品牌保护",
            "竞品监测",
            "广告投放",
            "账号管理"
          ],
          buname: "方案咨询",
        },
        {
          id: 2,
          Hname: "全球数据中心代理",
          text: "基于全球顶级IDC机房的高性能代理服务，为企业提供快速、稳定的全球网络访问能力",
          textA: {
            A: "优质网络资源",
            B: "覆盖全球100+数据中心，Tier-4机房标准，超低延迟访问",
          },
          textB: {
            A: "极致性能体验",
            B: "千兆带宽接入，全球加速网络，平均响应时间<100ms",
          },
          textC: {
            A: "企业级保障",
            B: "故障自动切换，7*24运维监控，可用性保障99.99%",
          },
          features: [
            "高速带宽",
            "全球加速",
            "故障转移",
            "实时监控",
            "API集成",
            "数据加密"
          ],
          scenarios: [
            "跨境业务",
            "站点监测",
            "负载均衡",
            "网络加速"
          ],
          buname: "免费试用",
        },
      ],
    };
  },

  mounted() {},
  methods: {
    getSolutionIcon(name) {
      const icons = {
        '高效低成本方案': 'el-icon-money',
        '专业定制': 'el-icon-s-tools',
        '资源定制': 'el-icon-data-line'
      };
      return icons[name] || 'el-icon-s-platform';
    },

    getFeatureIcon(key) {
      const icons = {
        'textA': 'el-icon-star-on',
        'textB': 'el-icon-trophy',
        'textC': 'el-icon-medal'
      };
      return icons[key] || 'el-icon-check';
    },

    getSolutionImage(id) {
      const images = {
        0: 'http://apiupss.ppfly.top/images/solution-cost.svg',
        1: 'http://apiupss.ppfly.top/images/solution-custom.svg',
        2: 'http://apiupss.ppfly.top/images/solution-resource.svg'
      };
      return images[id] || 'http://apiupss.ppfly.top/images/solution-default.svg';
    },

    openWeChatChat() {
      // 实现微信咨询功能
      // this.$message({
      //   message: '正在为您接入客服...',
      //   type: 'success'
      // });
    },

    startTrial() {
      // 实现免费试用功能
      // this.$message({
      //   message: '正在为您准备试用环境...',
      //   type: 'success'
      // });
    },

    handleCheckboxChange(item) {
      if (!this.ruleForm.type.includes(item.label)) {
        item.inputValue = "";
      }
    },

    lunboclick(name) {
      switch(name) {
        case "资源定制":
          this.handleResourceCustomization();
          break;
        case "专业定制":
          this.handleProfessionalCustomization();
          break;
        case "高效低成本方案":
          this.handleCostEffectiveSolution();
          break;
      }
    },

    handleResourceCustomization() {
      this.$message({
        message: '正在为您定制资源方案...',
        type: 'info'
      });
      this.openWeChatChat();
    },

    handleProfessionalCustomization() {
      this.$message({
        message: '正在为您准备专业定制方案...',
        type: 'info'
      });
      this.openWeChatChat();
    },

    handleCostEffectiveSolution() {
      this.$message({
        message: '正在为您计算最优成本方案...',
        type: 'info'
      });
      this.openWeChatChat();
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message({
            message: '提交成功！我们的客服将尽快与您联系',
            type: 'success'
          });
        } else {
          this.$message.error('请完善表单信息');
          return false;
        }
      });
    },

    gsxxtijiao() {
      if (this.validateForm()) {
        this.$message({
          message: '企业信息提交成功！',
          type: 'success'
        });
      } else {
        this.$message.error('请完善必填信息');
      }
    },

    validateForm() {
      return this.ruleForm.gsqc && this.ruleForm.phones;
    }
  },
};
</script>

<style>
.checkbox_input {
  margin-bottom: 10px;
  /* 每个 checkbox 的间距 */
}

.box_inputs {
  margin-left: 20px;
  width: 150px;
  /* 输入框与 checkbox 的间距 */
}

.el-icon-message-solid {
  color: #409eff;
  font-size: 25px;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 500px;
  margin: 0;
}
</style>

<style scoped>
.el-icon-check {
  font-size: 22px;
  font-weight: 700;
  color: #6327d3;
  padding: 5px;
}

.el-header,
.el-footer {
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0;
}

.el-header {
  position: sticky;
  top: 0;
  background-color: #edf3fc;
  z-index: 5;
}

.security {
  position: relative;
}

.heads_top {
  position: absolute;
}

.H_sec {
  font-size: 54px;
  color: #1b2336;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
}

.security_main_body {
  padding: 0;
  overflow-x: hidden;
}

.hero-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;
  gap: 60px;
}

.hero-content {
  flex: 1;
  max-width: 600px;
}

.hero-title {
  font-size: 48px;
  line-height: 1.2;
  margin-bottom: 24px;
}

.gradient-text {
  background: linear-gradient(90deg, #6327d3, #8b4fff);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.normal-text {
  color: #1b2336;
  margin-left: 12px;
}

.hero-description {
  font-size: 18px;
  line-height: 1.6;
  color: #666;
  margin-bottom: 40px;
}

.hero-features {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 40px;
}

.hero-features .feature-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: rgba(99, 39, 211, 0.05);
  border-radius: 12px;
  transition: all 0.3s ease;
}

.hero-features .feature-item:hover {
  transform: translateY(-5px);
  background: rgba(99, 39, 211, 0.1);
}

.feature-icon {
  width: 48px;
  height: 48px;
  background: #6327d3;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-icon i {
  font-size: 24px;
  color: #fff;
}

.feature-text h3 {
  font-size: 16px;
  color: #1b2336;
  margin: 0 0 4px 0;
}

.feature-text p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.hero-actions {
  display: flex;
  gap: 20px;
}

.primary-button {
  min-width: 180px;
  height: 54px;
  font-size: 18px;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(90deg, #6327d3, #8b4fff);
  border: none;
  box-shadow: 0 8px 15px rgba(99, 39, 211, 0.2);
  transition: all 0.3s ease;
}

.primary-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 20px rgba(99, 39, 211, 0.3);
}

.secondary-button {
  min-width: 180px;
  height: 54px;
  font-size: 18px;
  font-weight: 500;
  color: #6327d3;
  background: rgba(99, 39, 211, 0.1);
  border: 2px solid transparent;
  transition: all 0.3s ease;
}

.secondary-button:hover {
  background: rgba(99, 39, 211, 0.15);
  border-color: #6327d3;
  transform: translateY(-2px);
}

.hero-image {
  flex: 1;
  max-width: 500px;
  position: relative;
}

.main-image {
  width: 100%;
  height: auto;
  animation: float 6s ease-in-out infinite;
}

.stats-cards {
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 20px;
}

.stat-card {
  background: #fff;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.stat-number {
  font-size: 24px;
  font-weight: 700;
  color: #6327d3;
  line-height: 1;
  margin-bottom: 4px;
}

.stat-number span {
  font-size: 16px;
  margin-left: 2px;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

.features-section {
  max-width: 1200px;
  margin: 100px auto;
  padding: 0 20px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.feature-card {
  background: #fff;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(99, 39, 211, 0.15);
}

.card-icon {
  width: 60px;
  height: 60px;
  margin-bottom: 20px;
}

.card-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.feature-card h3 {
  font-size: 20px;
  color: #1b2336;
  margin: 0 0 8px 0;
}

.feature-card p {
  font-size: 16px;
  color: #666;
  margin: 0 0 20px 0;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 14px;
  color: #333;
}

.feature-list li i {
  color: #6327d3;
  font-size: 16px;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
}

@media (max-width: 1200px) {
  .hero-section {
    flex-direction: column;
    text-align: center;
  }

  .hero-content {
    max-width: 100%;
  }

  .hero-features {
    max-width: 600px;
    margin: 40px auto;
  }

  .hero-actions {
    justify-content: center;
  }

  .hero-image {
    max-width: 80%;
    margin: 40px auto 60px;
  }

  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 36px;
  }

  .hero-features {
    grid-template-columns: 1fr;
  }

  .hero-actions {
    flex-direction: column;
    align-items: center;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .stats-cards {
    flex-direction: column;
    bottom: -120px;
  }
}

.solutions-section {
  max-width: 1200px;
  margin: 100px auto;
  padding: 0 20px;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: 40px;
  color: #1b2336;
  margin-bottom: 20px;
  font-weight: 600;
}

.section-description {
  font-size: 18px;
  color: #666;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

.solutions-carousel {
  margin-top: 60px;
}

.solution-card {
  background: linear-gradient(135deg, #fff 0%, #f8f9ff 100%);
  border-radius: 20px;
  padding: 40px;
  height: 100%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.solution-card::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, rgba(99, 39, 211, 0.1) 0%, rgba(139, 79, 255, 0.1) 100%);
  border-radius: 50%;
  transform: translate(150px, -150px);
  z-index: 0;
}

.solution-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(99, 39, 211, 0.15);
}

.solution-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
}

.solution-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 40px;
}

.solution-info {
  flex: 1;
  margin-right: 40px;
}

.solution-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #6327d3 0%, #8b4fff 100%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 20px rgba(99, 39, 211, 0.2);
}

.solution-icon i {
  font-size: 36px;
  color: #fff;
}

.solution-title {
  font-size: 32px;
  color: #1b2336;
  margin: 0 0 16px 0;
  font-weight: 600;
}

.solution-description {
  font-size: 18px;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.solution-features {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 40px;
}

.solution-features .feature-item {
  background: rgba(99, 39, 211, 0.05);
  border-radius: 16px;
  padding: 24px;
  transition: all 0.3s ease;
}

.solution-features .feature-item:hover {
  background: rgba(99, 39, 211, 0.1);
  transform: translateY(-5px);
}

.solution-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin: 40px 0;
}

.details-section {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.details-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  color: #1b2336;
  margin: 0 0 20px 0;
}

.details-title i {
  color: #6327d3;
  font-size: 20px;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

.detail-item i {
  color: #6327d3;
  font-size: 16px;
}

.detail-item:hover {
  color: #6327d3;
  transform: translateX(5px);
  transition: all 0.3s ease;
}

/* 为每个解决方案添加不同的强调色 */
.solution-0 .detail-item i {
  color: #6327d3;
}

.solution-1 .detail-item i {
  color: #2d7dd2;
}

.solution-2 .detail-item i {
  color: #f6416c;
}

@media (max-width: 1200px) {
  .solution-details {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .details-grid {
    grid-template-columns: 1fr;
  }
}

.feature-header {
  display: flex;
  gap: 16px;
}

.feature-icon {
  width: 48px;
  height: 48px;
  background: #6327d3;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.feature-icon i {
  font-size: 24px;
  color: #fff;
}

.feature-text {
  flex: 1;
}

.feature-text h4 {
  font-size: 18px;
  color: #1b2336;
  margin: 0 0 8px 0;
}

.feature-text p {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin: 0;
}

.solution-illustration {
  margin: 40px 0;
  text-align: center;
}

.solution-illustration img {
  max-width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

/* 为每个解决方案卡片添加不同的强调色 */
.solution-0 .solution-icon,
.solution-0 .feature-icon {
  background: linear-gradient(135deg, #6327d3 0%, #8b4fff 100%);
}

.solution-1 .solution-icon,
.solution-1 .feature-icon {
  background: linear-gradient(135deg, #2d7dd2 0%, #45b7d1 100%);
}

.solution-2 .solution-icon,
.solution-2 .feature-icon {
  background: linear-gradient(135deg, #f6416c 0%, #ff9776 100%);
}

/* 轮播图样式优化 */
.el-carousel__item {
  border-radius: 20px;
  overflow: hidden;
}

.el-carousel__item.is-active {
  transform: scale(1.05);
  transition: all 0.5s ease;
}

@media (max-width: 1200px) {
  .solution-features {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .solution-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .solution-info {
    margin-right: 0;
    margin-bottom: 24px;
  }

  .solution-features {
    grid-template-columns: 1fr;
  }
}

.solution-card {
  background: linear-gradient(135deg, #fff 0%, #f8f9ff 100%);
  border-radius: 30px;
  padding: 40px;
  height: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.solution-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 30px 60px rgba(99, 39, 211, 0.15);
}

.solution-content {
  max-width: 600px;
  margin: 0 auto;
}

.solution-icon {
  width: 80px;
  height: 80px;
  margin-bottom: 30px;
}

.solution-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.solution-title {
  font-size: 32px;
  color: #1b2336;
  margin-bottom: 16px;
  font-weight: 600;
}

.solution-description {
  font-size: 18px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 40px;
}

.solution-features {
  margin-bottom: 40px;
}

.feature-column {
  display: grid;
  gap: 24px;
}

.feature-item {
  background: rgba(99, 39, 211, 0.05);
  border-radius: 16px;
  padding: 24px;
  transition: all 0.3s ease;
}

.feature-item:hover {
  background: rgba(99, 39, 211, 0.1);
}

.feature-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.feature-header i {
  color: #6327d3;
  font-size: 20px;
}

.feature-header h4 {
  font-size: 18px;
  color: #1b2336;
  margin: 0;
}

.feature-item p {
  font-size: 16px;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

.solution-action {
  text-align: center;
}

.action-button {
  min-width: 200px;
  height: 54px;
  font-size: 18px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.action-button.primary {
  background: linear-gradient(90deg, #6327d3, #8b4fff);
  border: none;
  color: #fff;
}

.action-button.secondary {
  background: rgba(99, 39, 211, 0.1);
  border: 2px solid #6327d3;
  color: #6327d3;
}

.action-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(99, 39, 211, 0.2);
}

.action-button i {
  font-size: 16px;
  transition: transform 0.3s ease;
}

.action-button:hover i {
  transform: translateX(4px);
}

/* 轮播图样式优化 */
.el-carousel__item {
  border-radius: 30px;
  overflow: hidden;
}

.el-carousel__item.is-active {
  transform: scale(1.05);
  transition: all 0.5s ease;
}

@media (max-width: 1200px) {
  .solution-card {
    padding: 30px;
  }

  .solution-title {
    font-size: 28px;
  }

  .solution-description {
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .section-title {
    font-size: 32px;
  }

  .solution-card {
    padding: 20px;
  }

  .feature-item {
    padding: 16px;
  }

  .feature-header h4 {
    font-size: 16px;
  }

  .feature-item p {
    font-size: 14px;
  }
}

.security_C_div_A {
  margin-bottom: 150px;
}

.security_C_div_A_H {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 40px;
  color: #1b2336;
  text-align: center;
  margin-bottom: 24px;
}

.security_C_div_A_H_F {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 40px;
  color: #1b2336;
  text-align: center;
  margin-bottom: 100px;
}

.security_C_div_A_size {
  font-weight: 400;
  font-size: 17px;
  color: #545364;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}

.security_C_div_B {
  display: flex;
  justify-content: center;
  border-radius: 20px;
  background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.security_C_div_B_div {
  text-align: left;
  width: 556px;
  margin-top: 80px;
}

.security_C_div_B_div_H {
  font-family: SourceHanSansCN-Medium;
  font-size: 30px;
  color: #000;
}

.security_C_div_B_div_text {
  font-weight: 400;
  font-size: 16px;
  color: #000;
  line-height: 22px;
  margin-top: 25px;
  height: 66px;
}

.security_C_div_B_div_2 {
  display: flex;
  justify-content: center;
  height: 100px;
}

.security_C_div_B_div_2_left {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.security_C_div_B_div_2_left > div {
  width: 200px;
}

.security_C_div_B_div_2_ret {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.security_C_div_B_div_2_ret > div {
  font-size: 16px;
  color: #727181;
}

.ydy_but_A {
  width: 283px;
  height: 56px;
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  color: #edf3fc;
  background: #6327d3;
  border-radius: 28px;
  border: 0 solid #6327d3;
  margin-top: 50px;
  margin-bottom: 50px;
}

.security_D_text {
  width: max-content;
  margin: 0 auto 36px;
  box-sizing: border-box;
  padding: 0 10px;
  border-radius: 24px;
  background: #f8fbff;
  margin-top: 110px;
}

.security_D_div2 {
  display: flex;
  justify-content: center;
}

.security_D_div2_div {
  width: 1400px;
}

.input_s {
  width: 500px;
  margin: 20px;
  height: 200px;
  text-align: left;
}

.input_s_name {
  text-align: left;
  margin-left: 100px;
  margin-bottom: 20px;
  font-size: 18px;
  color: #1d2130;
  line-height: 22px;
  font-family: SourceHanSansCN-Medium;
  position: relative;
  margin-bottom: 26px;
  width: max-content;
}

.hongxing {
  color: red;
}

.div_forms_div {
  display: flex;
  justify-content: center;
}

.forms_div {
  width: 1100px;
}

.top_div_bott {
  display: flex;
  justify-content: space-between;
  margin-bottom: 120px;
}

.top_div_bottB {
  display: flex;
  justify-content: space-between;
}

.checkbox_input {
  width: 300px;
  display: flex;
  justify-content: space-between;
}

.ydy_but_gsxx {
  width: 283px;
  height: 56px;
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  color: #edf3fc;
  background: #6327d3;
  border-radius: 28px;
  border: 0 solid #6327d3;
}
.ydy_but_gsxx:hover {
  background: #371b69;
}

.cta-section {
  background: linear-gradient(135deg, #6327d3 0%, #8b4fff 100%);
  padding: 80px 0;
  margin-top: 100px;
  color: #fff;
  position: relative;
  overflow: hidden;
}

.cta-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('http://apiupss.ppfly.top/images/cta-pattern.svg') center/cover;
  opacity: 0.1;
}

.cta-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.cta-text {
  max-width: 600px;
  margin-bottom: 40px;
}

.cta-text h2 {
  font-size: 36px;
  font-weight: 600;
  margin: 0 0 20px 0;
}

.cta-text p {
  font-size: 18px;
  line-height: 1.6;
  opacity: 0.9;
  margin: 0 0 30px 0;
}

.cta-features {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.cta-features li {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
}

.cta-features i {
  width: 24px;
  height: 24px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.cta-actions {
  display: flex;
  gap: 20px;
  margin-top: 40px;
}

.cta-button {
  min-width: 200px;
  height: 54px;
  font-size: 18px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.cta-button.primary {
  background: #fff;
  color: #6327d3;
  border: none;
}

.cta-button.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.cta-button.secondary {
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid #fff;
  color: #fff;
}

.cta-button.secondary:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.cta-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 60px auto 0;
  padding: 0 20px;
}

.cta-stats .stat-item {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 30px;
  text-align: center;
  transition: all 0.3s ease;
}

.cta-stats .stat-item:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.15);
}

.stat-icon {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.stat-icon i {
  font-size: 30px;
  color: #fff;
}

.stat-value {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 16px;
  opacity: 0.9;
}

@media (max-width: 1200px) {
  .cta-features {
    grid-template-columns: repeat(2, 1fr);
  }

  .cta-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .cta-section {
    padding: 60px 0;
  }

  .cta-text h2 {
    font-size: 28px;
  }

  .cta-features {
    grid-template-columns: 1fr;
  }

  .cta-actions {
    flex-direction: column;
  }

  .cta-button {
    width: 100%;
  }

  .cta-stats {
    grid-template-columns: 1fr;
  }
}

.security_E {
  margin-top: 200px;
}

.testimonials-section {
  background: linear-gradient(135deg, #f8f9ff 0%, #f2f6ff 100%);
  padding: 100px 0;
  margin-top: 100px;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 60px auto 0;
  padding: 0 20px;
}

.testimonial-card {
  background: #fff;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.testimonial-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(99, 39, 211, 0.15);
}

.testimonial-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 24px;
}

.company-logo {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  object-fit: cover;
}

.company-info {
  flex: 1;
}

.company-name {
  font-size: 18px;
  color: #1b2336;
  margin: 0 0 4px 0;
  font-weight: 600;
}

.company-industry {
  font-size: 14px;
  color: #666;
}

.testimonial-content {
  position: relative;
}

.testimonial-quote {
  background: rgba(99, 39, 211, 0.05);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  position: relative;
}

.quote-icon {
  position: absolute;
  top: -12px;
  left: -12px;
  width: 32px;
  height: 32px;
  background: #6327d3;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
}

.testimonial-quote p {
  font-size: 16px;
  color: #333;
  line-height: 1.6;
  margin: 0;
}

.testimonial-metrics {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.metric {
  text-align: center;
  padding: 16px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid rgba(99, 39, 211, 0.1);
}

.metric-value {
  display: block;
  font-size: 24px;
  font-weight: 700;
  color: #6327d3;
  margin-bottom: 4px;
}

.metric-label {
  font-size: 14px;
  color: #666;
}

@media (max-width: 1200px) {
  .testimonials-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .testimonials-grid {
    grid-template-columns: 1fr;
  }

  .testimonial-card {
    padding: 20px;
  }

  .testimonial-quote {
    padding: 20px;
  }

  .testimonial-metrics {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}
</style>
